<template>
    <div class="container my-4">
        <div class="row">
            <!-- WhatsApp Card -->
            <div class="col-md-4 mb-4">
                <div class="card text-center whatsapp-card">
                    <div class="card-body">
                        <h5 class="card-title"> <img src="@/assets/icons/whatsapp.png" alt="id" height="50">
                        </h5>
                        <p class="card-text">Stay connected with your friends and family on <strong>WhatsApp</strong>.
                        </p>
                        <a href="https://wa.me/918494998677?text=Hi%2C%20looking for services" target="_blank"><button
                                class="btn btn-success">Open WhatsApp</button>

                        </a>
                    </div>
                </div>
            </div>

            <!-- Instagram Card -->
            <div class="col-md-4 mb-4">
                <div class="card text-center instagram-card">
                    <div class="card-body">
                        <h5 class="card-title"><img src="@/assets/icons/instagram.png" alt="id" height="50"></h5>
                        <p class="card-text">Share your best moments and explore amazing content on
                            <strong>Instagram</strong>.
                        </p>
                        <a href="https://www.instagram.com/advance_accounting_co/" target="_blank">
                            <button class="btn btn-danger">Open Instagram</button></a>

                    </div>
                </div>
            </div>

            <!-- Twitter Card -->
            <div class="col-md-4 mb-4">
                <div class="card text-center twitter-card">
                    <div class="card-body">
                        <h5 class="card-title"><img src="@/assets/icons/twitter.png" alt="id" height="50"></h5>
                        <p class="card-text">Join the conversation and stay updated on <strong>Twitter</strong>.</p>
                        <a href="https://twitter.com/AdvanceAccco" target="_blank">
                            <button class="btn btn-primary">Open Twitter</button></a>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SocialMediaCards",
};
</script>

<style scoped>
.whatsapp-card {
    border-color: #25d366;
}

.instagram-card {
    border-color: #e4405f;
}

.twitter-card {
    border-color: #1da1f2;
}

.card {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
}

.card-body i {
    font-size: 3rem;
}
</style>